module.exports = __webpack_public_path__ + "static/media/version_loading.4774f1ce.gif";